import { useMutation } from '@tanstack/react-query'

import { syncPointUsageToAccountingService } from '@src/api'
import { DefaultApiSyncPointUsageToAccountingServiceRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useSyncPointUsageToAccountingService = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiSyncPointUsageToAccountingServiceRequest) =>
      syncPointUsageToAccountingService(axiosInstance, params),
  })
}
